import { useContext } from "react";
import { observer } from "mobx-react-lite";
import { useEffectOnce } from "@lib-shared/hooks";
import { Button, ButtonToolbar } from "@shared-forms";
import { AppContext } from "core/app-context";
import { Page } from "core/constants";
import { Installation } from "core/models/installation-response";
import InstallationCard from "./installation-card";

type InstallationsProps = {
    onSelect: (installation: Installation) => void,
    onBack: () => void
}

const Installations = observer((props: InstallationsProps) => {
    const store = useContext(AppContext);
    const { onBack, onSelect } = props;

    useEffectOnce(() => store.updatePage(Page.installations));

    const installations = store.installations;

    if (!installations?.length) {
        return <>
            <p>
                You have no scheduled installations
            </p>

            <ButtonToolbar>
                <Button colour="unset" onClick={onBack} text="Back" className="back" />
            </ButtonToolbar>
        </>;
    }

    return (<>
        <ul className="installations">
            {installations.map((i, ix) => <InstallationCard key={ix} installation={i} onSelect={onSelect} />)}
        </ul>

        <ButtonToolbar>
            <Button colour="unset" onClick={onBack} text="Back" className="back" />
        </ButtonToolbar>
    </>
    );
});

export default Installations;
